export default __webpack_public_path__ + "static/media/L&T.6d55b332.jpg";